import { render, staticRenderFns } from "./regPage.vue?vue&type=template&id=0784c132&scoped=true"
import script from "./regPage.vue?vue&type=script&lang=js"
export * from "./regPage.vue?vue&type=script&lang=js"
import style0 from "./regPage.vue?vue&type=style&index=0&id=0784c132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784c132",
  null
  
)

export default component.exports